/**
 * Trust badges — Visa, Mastercard, Troy, iyzico.
 * All logos are inline SVG (brand-accurate but simplified enough for a footer
 * strip) so there is no external asset dependency.
 */

function Visa({ size = 40 }) {
  return (
    <svg viewBox="0 0 96 32" width={size * 2.4} height={size * 0.8} aria-label="Visa">
      <rect width="96" height="32" fill="#ffffff" rx="3" />
      <text
        x="48" y="22"
        textAnchor="middle"
        fontFamily="Arial Black, Arial, sans-serif"
        fontSize="20"
        fontStyle="italic"
        fontWeight="900"
        fill="#1a1f71"
        letterSpacing="1"
      >VISA</text>
    </svg>
  );
}

function Mastercard({ size = 40 }) {
  return (
    <svg viewBox="0 0 60 40" width={size * 1.5} height={size} aria-label="Mastercard">
      <rect width="60" height="40" fill="#ffffff" rx="3" />
      <circle cx="24" cy="20" r="11" fill="#EB001B" />
      <circle cx="36" cy="20" r="11" fill="#F79E1B" />
      <path d="M30 12 A11 11 0 0 0 30 28 A11 11 0 0 0 30 12" fill="#FF5F00" />
    </svg>
  );
}

function Troy({ size = 40 }) {
  return (
    <svg viewBox="0 0 96 32" width={size * 2.4} height={size * 0.8} aria-label="Troy">
      <rect width="96" height="32" fill="#ffffff" rx="3" />
      {/* Türk bayrağı esintili kırmızı-turkuaz aksan */}
      <path d="M6 16 Q10 8 18 12 Q26 16 34 10" stroke="#ee1c25" strokeWidth="3" fill="none" strokeLinecap="round" />
      <text
        x="52" y="21"
        fontFamily="Arial, sans-serif"
        fontSize="15"
        fontWeight="800"
        fill="#00afca"
        letterSpacing="0.5"
      >troy</text>
    </svg>
  );
}

function PayTR({ size = 40 }) {
  return (
    <svg viewBox="0 0 96 32" width={size * 2.4} height={size * 0.8} aria-label="PayTR">
      <defs>
        <linearGradient id="paytrGrad" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor="#0d3d8f" />
          <stop offset="100%" stopColor="#1e64ff" />
        </linearGradient>
      </defs>
      <rect width="96" height="32" fill="#ffffff" rx="3" />
      <text
        x="48" y="21.5"
        textAnchor="middle"
        fontFamily="Arial Black, Arial, sans-serif"
        fontSize="16"
        fontWeight="900"
        fill="url(#paytrGrad)"
        letterSpacing="0.3"
      >PayTR</text>
      {/* Micro-accent — money/security dot */}
      <circle cx="76" cy="10" r="2.4" fill="#e11d48" />
    </svg>
  );
}

/**
 * Compact horizontal payment-brands strip for footers, checkout pages, etc.
 * All whites-on-dark friendly (each mark is a white rounded rect).
 * PayTR is our current PCI-DSS gateway; iyzico is retained for brand recognition
 * but styled less prominently — it may be removed once launch stabilizes.
 */
export default function PaymentLogos({ size = 34, className = "" }) {
  return (
    <div
      className={`flex flex-wrap items-center gap-2.5 sm:gap-3 ${className}`}
      data-testid="payment-logos"
    >
      <Visa size={size} />
      <Mastercard size={size} />
      <Troy size={size} />
      <PayTR size={size} />
    </div>
  );
}
